import { apiRequest } from '../request'
import { ApiResponse } from '../request'

export interface Payment {
    id: string
    asaasPaymentId: string
    companyId: number
    orderId?: number
    clientId: number
    value: number
    netValue?: number
    originalValue?: number
    interestValue?: number
    description?: string
    billingType: 'CREDIT_CARD' | 'PIX' | 'BOLETO'
    status:
        | 'PENDING'
        | 'RECEIVED'
        | 'CONFIRMED'
        | 'OVERDUE'
        | 'REFUNDED'
        | 'RECEIVED_IN_CASH'
        | 'CHARGEBACK_REQUESTED'
        | 'CHARGEBACK_DISPUTE'
        | 'AWAITING_CHARGEBACK_REVERSAL'
        | 'DUNNING_REQUESTED'
        | 'DUNNING_RECEIVED'
        | 'AWAITING_RISK_ANALYSIS'
        | 'APPROVED'
        | 'REJECTED'
    dueDate: string
    originalDueDate?: string
    paymentDate?: string
    clientPaymentDate?: string
    confirmedDate?: string
    creditDate?: string
    estimatedCreditDate?: string
    installmentNumber?: number
    invoiceUrl?: string
    invoiceNumber?: string
    externalReference?: string
    creditCardNumber?: string
    creditCardBrand?: string
    creditCardToken?: string
    pixQrCode?: string
    pixQrCodeBase64?: string
    pixCopyPaste?: string
    pixExpirationDate?: string
    bankSlipUrl?: string
    nossoNumero?: string
    transactionReceiptUrl?: string
    metadata?: any
    createdAt: string
    updatedAt: string
    company?: {
        id: number
        name: string
        tradingName?: string
    }
    order?: {
        id: number
        name?: string
        status: string
        type: string
    }
    client?: {
        id: number
        name: string
        email?: string
        whatsAppNumber?: string
    }
}

export interface SubscriptionPayment {
    id: number
    subscriptionId: number
    organizationId: number
    amount: number
    status: string
    paymentId: string
    description?: string
    billingType?: string
    creditCardNumber?: string
    creditCardBrand?: string
    dateRef: string
    createdAt: string
    updatedAt: string
    subscription?: {
        plan?: {
            name: string
            price: number
            customPrice?: number
        }
    }
}

export async function getSubscriptionPayments(
    organizationId: number
): Promise<ApiResponse<SubscriptionPayment[]>> {
    return apiRequest<SubscriptionPayment[]>(
        `subscriptions/payments/${organizationId}`,
        {}
    )
}

export async function getPayments(params?: {
    companyId?: number
    orderId?: number
    clientId?: number
}): Promise<ApiResponse<Payment[]>> {
    return apiRequest<Payment[]>('payments', {
        params,
    })
}

export async function getPayment(id: string): Promise<ApiResponse<Payment>> {
    return apiRequest<Payment>('payments', {
        id,
    })
}

export async function getPixQrCode(
    id: string
): Promise<ApiResponse<{
    qrCode: string
    qrCodeBase64: string
    copyPaste: string
    expirationDate: string
}>> {
    return apiRequest(`payments/${id}/pix-qrcode`, {})
}

export async function retryPayment(
    id: string
): Promise<ApiResponse<any>> {
    return apiRequest(`payments/${id}/retry`, {}, 'post')
}
